import { render, staticRenderFns } from "./survey-step-chronic-inflammatory-conditions.vue?vue&type=template&id=dc7c0da8"
import script from "./survey-step-chronic-inflammatory-conditions.vue?vue&type=script&lang=js"
export * from "./survey-step-chronic-inflammatory-conditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports